// import { getDefaultStore } from 'jotai';
import { activeChildDetail, alertModal, appConstants, appCurrentVersion, auth_token, changeChild, childList, childSelectAtom, currentAppScreen, deviceFCMToken, historyStack, last_login_time, last_reload, last_reload_time, Login_Form, Login_Success, parentProfile, save_otp, selectedSupportItem, surevyflag, survey_id, userstate } from './store';
import { store } from './store';
import { isAppVersionOutdatedError, showAppUpdateModal } from '../utils/appUpdate';

export const getAuthToken = () => {
    return store.get(auth_token);
};
export const getSurvey = () => {

    // console.log("store", store.get(survey_id));
    return store.get(survey_id);
};
export const getReloadTime = () => {

    console.log("store", store.get(last_reload_time));
    return store.get(last_reload_time);
};
export const getActiveChild = () => {

    // console.log('store', store.get(activeChildDetail));
    return store.get(activeChildDetail);
};
export const getChildList = () => {
    return store.get(childList);
};
export const getUserState = () => {

    // console.log("store", store.get(userstate));
    return store.get(userstate);
};
export const getLastLogin = () => {

    // console.log("store", store.get(last_login_time));
    return store.get(last_login_time);
};
export const getAppConstants = () => {

    return store.get(appConstants);
};
export const getDeviceToken = () => {

    return store.get(deviceFCMToken);
};
export const getAppCurrentVersion = () => {
    return store.get(appCurrentVersion);
};
export const getParent = () => {
    return store.get(parentProfile);
};
export const getModal = () => {
    return store.get(alertModal);
};

export const getRelaod = () => {
    return store.get(last_reload)
}
export const getShowOverlay = () => {
    return store.get(changeChild);
};
export const getSignedInData = () => {
    return store.get(Login_Form);
};
export const getSavedOtp = () => {
    return store.get(save_otp);
};


export const setReload = (data) => {
    return store.set(last_reload, data)
}

export const setDeviceToken = (data) => {
    return store.set(deviceFCMToken, data);
};
export const setAppCurrentVersion = data => {
    return store.set(appCurrentVersion, data);
};
export const setAppConstants = (data) => {

    return store.set(appConstants, data);
};
export const setLastLogin = (data) => {

    // console.log("store", store.get(last_login_time));
    return store.set(last_login_time, data);
};
export const setAuthToken = (data) => {
    //   console.log('store', store.set(activeChildDetail,data));
    return store.set(auth_token, data);
};
export const setActiveChild = (data) => {
    //   console.log('store', store.set(activeChildDetail,data));
    return store.set(activeChildDetail, data);
};
export const setUserState = (data) => {


    return store.set(userstate, data);
};
export const setChildList = (data) => {


    return store.set(childList, data);
};
export const setParentProfile = (data) => {


    return store.set(parentProfile, data);
};

export const setSurvey = (data) => {

    return store.set(survey_id, data);
};
export const setReloadTime = (data) => {
    console.log("setting reload time ", data)
    return store.set(last_reload_time, data);
};
export const setAlertModal = (data) => {
    if (isAppVersionOutdatedError(data?.message)) {
        showAppUpdateModal(data.message);
        return;
    }
    return store.set(alertModal, data);
};
export const setLoginSuccess = (data) => {
    return store.set(Login_Success, data);
};
export const setOTP = (data) => {
    return store.set(save_otp, data);
};
export const setShowOverlay = (data) => {
    return store.set(changeChild, data);
};
export const setSignedInData = (data) => {
    return store.set(Login_Form, data);
};
export const setSelectChild = (data) => {
    return store.set(childSelectAtom, data);
};

export const setCurrentScreen = (newScreen) => {
    const prevScreen = store.get(currentAppScreen);

    // Do NOT push if navigating to same screen
    if (prevScreen !== newScreen) {
        store.set(historyStack, (stack) => [...stack, prevScreen]);
    }

    return store.set(currentAppScreen, newScreen);
};


export const setSupportItem = (data) => {
    return store.set(selectedSupportItem, data);
}



